import createReducer from '../../common/util/createReducer';
import {ActionTypes} from '../actions';
import {downloadFile} from '../../common/util/file';
import {replaceItem} from '../../common/util/array';

const INITIAL_STATE = {
  'loading': false,
  'updating': false,
  'downloading': false,
  'loadingLog': false,
  'selectedInvoice': null,
  'filters': {
    'invoice': '',
    'provider': '',
    'orderType': '',
    'transport': '',
    'status': 'pending',
  },
  'list': [],
  'filteredList': [],
  'listByPage': [],
  'auditLog': [],
  'pageSize': 20,
  'pageNumber': 0,
};

const getPage = (list, pageNumber, pageSize) => {
  if (list.length <= pageSize) {
    return [...list];
  }
  if (list.length > (pageSize * (pageNumber + 1))) {
    return [...list].slice(
      (pageSize * pageNumber),
      (pageSize * (pageNumber + 1))
    );
  }
  return [...list].slice(pageNumber * pageSize);
};

const updateInfo = (list, {etaUpdated, observation, invoice}) => {
  const index = list.findIndex((bill) => bill.code === invoice);
  const newObject = {...list[index], 'etdDate': etaUpdated, 'observation': observation};

  return replaceItem(list, index, newObject);
};

const filterList = (list, {invoice, provider, orderType, transport}) => {
  return list.filter((bill) => bill.code.startsWith(invoice) && bill.providerName.includes(provider) &&
  bill.orderType.includes(orderType) && bill.transport.includes(transport));
};

export const providersImportations = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_PROVIDERS_IMPORTATIONS]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_PROVIDERS_IMPORTATIONS]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
      'filteredList': action.response.data,
      'listByPage': [...getPage(action.response.data, 0, state.pageSize)],
    }),
    [ActionTypes.FETCHED_PROVIDERS_IMPORTATIONS_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
      'filteredList': [],
      'listByPage': [],
    }),
    [ActionTypes.CHANGE_PROVIDERS_IMPORTATIONS_LIST_PAGE]: (state, action) => ({
      ...state,
      'pageNumber': action.payload,
      'listByPage': [...getPage(state.filteredList, action.payload, state.pageSize)],
    }),
    [ActionTypes.CHANGE_PROVIDERS_IMPORTATIONS_LIST_PAGE_SIZE]: (state, action) => ({
      ...state,
      'pageSize': action.payload,
      'pageNumber': 0,
      'listByPage': [...getPage(state.filteredList, 0, action.payload)],
    }),
    [ActionTypes.EDIT_IN_TRANSIT_IMPORTS_FILTER]: (state, action) => {
      const {list, filters, pageNumber, pageSize} = state;
      const newFilters = {...filters, [action.payload.filter]: action.payload.value};
      const filteredList = filterList(list, newFilters);

      return {
        ...state,
        'filters': newFilters,
        'filteredList': filteredList,
        'listByPage': getPage(filteredList, pageNumber, pageSize),
      };
    },
    [ActionTypes.CLEAR_IN_TRANSIT_IMPORTS_FILTERS]: (state, action) => ({
      ...state,
      'filters': INITIAL_STATE.filters,
      'filteredList': state.list,
      'listByPage': getPage(state.list, state.pageNumber, state.pageSize),
    }),
    [ActionTypes.UPDATING_PROVIDERS_IMPORTATIONS]: (state, action) => ({
      ...state,
      'updating': true,
    }),
    [ActionTypes.UPDATED_PROVIDERS_IMPORTATIONS]: (state, action) => {
      const listUpdated = updateInfo(state.list, action.payload);
      const filteredList = filterList(listUpdated, state.filters);

      return ({
        ...state,
        'updating': false,
        'list': listUpdated,
        'filteredList': filteredList,
        'listByPage': [...getPage(filteredList, state.pageNumber, state.pageSize)],
      });
    },
    [ActionTypes.UPDATED_PROVIDERS_IMPORTATIONS_FAILED]: (state, action) => ({
      ...state,
      'updating': false,
    }),
    [ActionTypes.DOWNLOAD_IN_TRANSIT_IMPORTS_REQUEST]: (state, action) => ({
      ...state,
      'downloading': true,
    }),
    [ActionTypes.DOWNLOAD_IN_TRANSIT_IMPORTS_SUCCESS]: (state, action) => {
      downloadFile(action.response.data);

      return {
        ...state,
        'downloading': false,
      };
    },
    [ActionTypes.DOWNLOAD_IN_TRANSIT_IMPORTS_FAILED]: (state, action) => ({
      ...state,
      'downloading': false,
    }),
    [ActionTypes.EDIT_IN_TRANSIT_SELECTED_INVOICE]: (state, action) => ({
      ...state,
      'selectedInvoice': action.payload,
    }),
    [ActionTypes.UPDATE_INVOICE_PORT_ARRIVAL_DATE_REQUEST]: (state, action) => ({
      ...state,
      'updating': true,
    }),
    [ActionTypes.UPDATE_INVOICE_PORT_ARRIVAL_DATE_SUCCESS]: (state, action) => ({
      ...state,
      'updating': false,
    }),
    [ActionTypes.UPDATE_INVOICE_PORT_ARRIVAL_DATE_FAILED]: (state, action) => ({
      ...state,
      'updating': false,
    }),
    [ActionTypes.GET_PORT_ARRIVAL_AUDIT_LOG_REQUEST]: (state, action) => ({
      ...state,
      'loadingLog': true,
    }),
    [ActionTypes.GET_PORT_ARRIVAL_AUDIT_LOG_SUCCESS]: (state, action) => ({
      ...state,
      'loadingLog': false,
      'auditLog': action.response.data,
    }),
    [ActionTypes.GET_PORT_ARRIVAL_AUDIT_LOG_FAILED]: (state, action) => ({
      ...state,
      'loadingLog': false,
      'auditLog': [],
    }),
  })(state, action);
};
